import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';

import { CLEAR_ERROR } from '../../../action/user_action_types';

//Showing the error for all
const Error = ({ error, removeError }) => {

  if(error) {
    setTimeout(() => {
      removeError();
    }, 2000);
  }

  const showError= ()=> {
    toast.error(error, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: false,
      hideProgressBar: true,
      toastId: "1"
    })
  }

  return error ? (
    <div>
      <ToastContainer />
      {showError()}
    </div>
  ) : null;
};

function mapStateToProps(state) {
  return {
    error: state.userError.get('error')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    removeError: () => dispatch({
      type: CLEAR_ERROR,
      payload: null
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Error);



// WEBPACK FOOTER //
// ./web/components/admin/common/Error.jsx